import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Skill = styled.div`
  border: 1px solid #e6e6e6;
  padding: 24px;
  border-radius: 12px;
`
export const TopSkill = styled.span`
  padding: 4px 8px;
  border-radius: 6px;
  margin-left: 8px;
  margin-top: 0;
  font-size: 13px;
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  text-align: center;

  ${(props) => css`
    background-color: ${props.theme.colors.primary};
    color: ${props.theme.colors.body};
  `}

  ${breakpoint("tablet")`
    margin-top: 0;
    margin-left: 10px;
  `}
`

export const SkillName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const SkillQualifications = styled.div`
  margin-top: 1rem;
`

export const SkillLevel = styled.span`
  font-size: 0.7em;
  font-weight: normal;
  letter-spacing: 0.1px;
`
